import { render } from "./headerComponent.vue?vue&type=template&id=f1c294fe&scoped=true&bindings={\"name\":\"setup\"}"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=f1c294fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f1c294fe"

export default script